import { Input as UIKitInput } from "@credit-acceptance/uikit";
import type { ComponentProps } from "react";

import { cn } from "../../../lib/utils";

type CurrencyInputProperties = ComponentProps<typeof UIKitInput>;

/**
 * uikit's currency Input, pinned to the workbench's control size.
 *
 * uikit defaults to `size="medium"` (40px), which left the pay fields towering
 * over every other control in the form at 24px. This pins `size="small"` in one
 * place, the same way ./input.tsx does for text inputs, so the two stay in step.
 *
 * `min-w-0` is added for the same reason as in ./input.tsx: uikit leaves it off
 * the outer element, so without it the control cannot shrink below the
 * `<input>`'s intrinsic width and overflows narrow grid columns.
 *
 * Props are otherwise uikit's own — callers pass `kind="currency"`, `currency`,
 * `precision`, and `controls` straight through.
 */
function CurrencyInput({ className, ...properties }: CurrencyInputProperties) {
  return <UIKitInput size="small" {...properties} className={cn("min-w-0", className)} />;
}

export { CurrencyInput };
